import React from 'react';
import styles from './Title.module.css';

const Title = (props) => {
    const { text ,color } = props;
    return (
        <div className={styles.container}>
            <h1 
            className={styles.title} 
            style={{ color: color }}>{text}</h1>
        </div>
    );
};

export default Title;
